import React from 'react';

var Network = /*#__PURE__*/function () {
  function Network(nodesMap, edgesMap, commoditiesMap) {
    this.nodesMap = nodesMap;
    this.edgesMap = edgesMap;
    this.commoditiesMap = commoditiesMap;
  }
  Network.fromJson = function fromJson(json) {
    var nodes = json['nodes'];
    var edges = json['edges'];
    var commodities = json['commodities'];
    var nodesMap = nodes.reduce(function (acc, node) {
      acc[node.id] = node;
      return acc;
    }, {});
    var edgesMap = edges.reduce(function (acc, edge) {
      acc[edge.id] = edge;
      return acc;
    }, {});
    var commoditiesMap = commodities.reduce(function (acc, comm) {
      acc[comm.id] = comm;
      return acc;
    }, {});
    return new Network(nodesMap, edgesMap, commoditiesMap);
  };
  return Network;
}();

function elemLRank(arr, x) {
  if (x < arr[0]) {
    return -1;
  }
  var low = 0;
  var high = arr.length;
  while (high > low) {
    var mid = Math.floor((high + low) / 2);
    if (x < arr[mid]) {
      high = mid;
    } else {
      // arr[mid] <= x
      low = mid + 1;
    }
  }
  return high - 1;
}
function elemRank(arr, x) {
  if (x <= arr[0]) {
    return -1;
  }
  var low = 0;
  var high = arr.length;
  while (high > low) {
    var mid = Math.floor((high + low) / 2);
    if (x <= arr[mid]) {
      high = mid;
    } else {
      low = mid + 1;
    }
  }
  return high - 1;
}
var mergeLists = function mergeLists(lists) {
  var indices = lists.map(function () {
    return 0;
  });
  var curVal = Math.min.apply(Math, lists.map(function (list) {
    return list[0];
  }));
  var merged = [curVal];
  while (true) {
    var min = Infinity;
    var listIndex = -1;
    for (var i = 0; i < lists.length; i++) {
      if (indices[i] < lists[i].length - 1 && lists[i][indices[i] + 1] <= min) {
        min = lists[i][indices[i] + 1];
        listIndex = i;
      }
    }
    if (listIndex == -1) {
      return merged;
    } else {
      merged.push(min);
      indices[listIndex] += 1;
    }
  }
};

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var isArrayOfNumbers = function isArrayOfNumbers(value) {
  if (!Array.isArray(value)) return false;
  for (var _iterator = _createForOfIteratorHelperLoose(value), _step; !(_step = _iterator()).done;) {
    var entry = _step.value;
    if (typeof entry !== 'number') return false;
  }
  return true;
};

var PiecewiseLinear = /*#__PURE__*/function () {
  function PiecewiseLinear(times, values, firstSlope, lastSlope) {
    this.times = times;
    this.values = values;
    this.lastSlope = lastSlope;
    this.firstSlope = firstSlope;
  }
  var _proto = PiecewiseLinear.prototype;
  _proto.eval = function _eval(at) {
    var rnk = elemRank(this.times, at);
    return this._evalWithRank(at, rnk);
  };
  _proto.gradient = function gradient(rnk) {
    if (rnk === -1) return this.firstSlope;
    if (rnk === this.times.length - 1) return this.lastSlope;
    return (this.values[rnk + 1] - this.values[rnk]) / (this.times[rnk + 1] - this.times[rnk]);
  };
  _proto._evalWithRank = function _evalWithRank(at, rnk) {
    if (rnk === -1) {
      var first_grad = this.gradient(rnk);
      return this.values[0] + (at - this.times[0]) * first_grad;
    } else if (rnk === this.times.length - 1) {
      var last_grad = this.gradient(rnk);
      return this.values[this.values.length - 1] + (at - this.times[this.times.length - 1]) * last_grad;
    }
    return this.values[rnk] + (at - this.times[rnk]) * this.gradient(rnk);
  };
  PiecewiseLinear.fromJson = function fromJson(json) {
    if (!isArrayOfNumbers(json['times']) || !isArrayOfNumbers(json['values']) || typeof json['lastSlope'] !== 'number' || typeof json['firstSlope'] !== 'number') {
      throw TypeError('Could not parse PiecewiseLinear.');
    }
    return new PiecewiseLinear(json['times'], json['values'], json['firstSlope'], json['lastSlope']);
  };
  return PiecewiseLinear;
}();

var RightConstant = /*#__PURE__*/function () {
  function RightConstant(times, values) {
    this.times = times;
    this.values = values;
  }
  var _proto = RightConstant.prototype;
  _proto.eval = function _eval(at) {
    var rnk = elemLRank(this.times, at);
    return this._evalWithLRank(rnk);
  };
  _proto._evalWithLRank = function _evalWithLRank(rnk) {
    if (rnk === -1) {
      return this.values[0];
    } else {
      return this.values[rnk];
    }
  };
  RightConstant.fromJson = function fromJson(json) {
    if (!isArrayOfNumbers(json['times']) || !isArrayOfNumbers(json['values'])) {
      throw TypeError('Could not parse RightConstant.');
    }
    return new RightConstant(json['times'], json['values']);
  };
  return RightConstant;
}();

function mapValues(object, fn) {
  return Object.keys(object).reduce(function (result, key) {
    var key2 = key;
    var result2 = result;
    result2[key2] = fn(object[key2], key2);
    return result;
  }, {});
}
function groupBy(obj, by) {
  var result = {};
  for (var key in obj) {
    var value = obj[key];
    var group = by(value);
    if (!result[group]) {
      result[group] = [];
    }
    result[group].push(value);
  }
  return result;
}

var Flow = /*#__PURE__*/function () {
  function Flow(inflow, outflow, queues) {
    this.inflow = inflow;
    this.outflow = outflow;
    this.queues = queues;
  }
  Flow.fromJson = function fromJson(json) {
    var inflow = json['inflow'].map(function (inflows) {
      return mapValues(inflows, function (rightConstant) {
        return RightConstant.fromJson(rightConstant);
      });
    });
    var outflow = json['outflow'].map(function (outflows) {
      return mapValues(outflows, function (rightConstant) {
        return RightConstant.fromJson(rightConstant);
      });
    });
    var queues = json['queues'].map(function (queue) {
      return PiecewiseLinear.fromJson(queue);
    });
    return new Flow(inflow, outflow, queues);
  };
  return Flow;
}();

var d = {
  M: function M(x, y) {
    return "M" + x + " " + y;
  },
  c: function c(dx1, dy1, dx2, dy2, x, y) {
    return "c" + dx1 + " " + dy1 + " " + dx2 + " " + dy2 + " " + x + " " + y;
  },
  l: function l(x, y) {
    return "l" + x + " " + y;
  },
  L: function L(x, y) {
    return "L" + x + " " + y;
  },
  h: function h(x) {
    return "h" + x;
  },
  H: function H(x) {
    return "H" + x;
  },
  v: function v(y) {
    return "v" + y;
  },
  V: function V(y) {
    return "V" + y;
  },
  m: function m(x, y) {
    return "m" + x + " " + y;
  },
  z: 'z',
  A: function A(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
    return "A" + rx + " " + ry + " " + xAxisRotation + " " + largeArcFlag + " " + sweepFlag + " " + x + " " + y;
  }
};

var calcOutflowSteps = function calcOutflowSteps(outflow, commodities) {
  var outflowTimes = mergeLists(Object.values(outflow).map(function (pwConstant) {
    return pwConstant.times;
  }));
  // Every two subsequent values in outflowTimes correspond to a flow step.
  var flowSteps = [];
  for (var i = 0; i < outflowTimes.length - 1; i++) {
    // Block from i to i+1
    var start = outflowTimes[i];
    var end = outflowTimes[i + 1];
    var values = [];
    for (var _i = 0, _Object$keys = Object.keys(outflow); _i < _Object$keys.length; _i++) {
      var c = _Object$keys[_i];
      values.push({
        color: commodities[c].color,
        value: outflow[c].eval(start)
      });
    }
    flowSteps.push({
      start: start,
      end: end,
      values: values
    });
  }
  return flowSteps;
};
var splitOutflowSteps = function splitOutflowSteps(outflowSteps, queue, transitTime, capacity, t) {
  var inEdgeSteps = [];
  var tPlusTransitTime = t + transitTime;
  for (var _iterator = _createForOfIteratorHelperLoose(outflowSteps), _step; !(_step = _iterator()).done;) {
    var _step2 = _step.value;
    var relStart = _step2.start - t;
    var relEnd = _step2.end - t;
    if (_step2.start > tPlusTransitTime) {
      break;
    }
    var inEdgeStart = Math.max(relStart, 0);
    var inEdgeEnd = Math.min(relEnd, transitTime);
    if (inEdgeStart < inEdgeEnd) {
      inEdgeSteps.push({
        start: inEdgeStart,
        end: inEdgeEnd,
        values: _step2.values
      });
    }
  }
  var queueSteps = [];
  var queueSize = queue.eval(t);
  if (queueSize <= 0) return {
    queueSteps: queueSteps,
    inEdgeSteps: inEdgeSteps
  };
  var firstIndexInQueue = null;
  for (var i = 0; i < outflowSteps.length; i++) {
    var step = outflowSteps[i];
    if (step.end >= tPlusTransitTime) {
      firstIndexInQueue = i;
      break;
    }
  }
  if (firstIndexInQueue === null) return {
    queueSteps: queueSteps,
    inEdgeSteps: inEdgeSteps
  };
  var accSize = 0;
  var _loop = function _loop() {
    var step = outflowSteps[_i2];
    var stepCapacity = step.values.reduce(function (acc, comm) {
      return acc + comm.value;
    }, 0);
    if (stepCapacity <= 0) return "continue";
    var stepSize = stepCapacity * (step.end - Math.max(tPlusTransitTime, step.start));
    var inQueueStart = accSize / capacity;
    var inQueueEnd = Math.min(accSize + stepSize, queueSize) / capacity;
    queueSteps.push({
      start: -inQueueEnd,
      end: -inQueueStart,
      values: step.values.map(function (_ref) {
        var color = _ref.color,
          value = _ref.value;
        return {
          color: color,
          value: value / stepCapacity * capacity
        };
      })
    });
    accSize += stepSize;
    if (accSize >= queueSize) return "break";
  };
  for (var _i2 = firstIndexInQueue; _i2 < outflowSteps.length; _i2++) {
    var _ret = _loop();
    if (_ret === "continue") continue;
    if (_ret === "break") break;
  }
  return {
    queueSteps: queueSteps,
    inEdgeSteps: inEdgeSteps
  };
};
var DynamicFlowSvgDefs = function DynamicFlowSvgDefs(_ref2) {
  var svgIdPrefix = _ref2.svgIdPrefix;
  return React.createElement(React.Fragment, null, React.createElement("linearGradient", {
    id: svgIdPrefix + "fade-grad",
    x1: "0",
    y1: "1",
    y2: "0",
    x2: "0"
  }, React.createElement("stop", {
    offset: "0",
    stopColor: "white",
    stopOpacity: "0.5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.2"
  })), React.createElement("mask", {
    id: svgIdPrefix + "fade-mask",
    maskContentUnits: "objectBoundingBox"
  }, React.createElement("rect", {
    width: "1",
    height: "1",
    fill: "url(#" + svgIdPrefix + "fade-grad)"
  })));
};
var computeDrawPathsFromInEdgeSteps = function computeDrawPathsFromInEdgeSteps(inEdgeSteps, flowScale, edgeStart, transitTime, normOffsetted) {
  var pathsByColor = {};
  var closePath = function closePath(paths) {
    if (paths.cur != null) {
      paths.previousParts.push(paths.cur.bottomPath + paths.cur.connectPath + paths.cur.topReversePath);
      paths.cur = null;
    }
  };
  var closePaths = function closePaths() {
    for (var _i3 = 0, _Object$keys2 = Object.keys(pathsByColor); _i3 < _Object$keys2.length; _i3++) {
      var key = _Object$keys2[_i3];
      var path = pathsByColor[key];
      closePath(path);
    }
  };
  var intervalsOverlap = function intervalsOverlap(a1, b1, a2, b2) {
    var _sort = [a1, b1].sort(function (a, b) {
        return a - b;
      }),
      low1 = _sort[0],
      high1 = _sort[1];
    var _sort2 = [a2, b2].sort(function (a, b) {
        return a - b;
      }),
      low2 = _sort2[0],
      high2 = _sort2[1];
    return !(high2 <= low1 || high1 <= low2);
  };
  var addRect = function addRect(color, x1, y1, x2, y2) {
    if (x1 == x2 || y1 == y2) {
      return;
    }
    var paths = pathsByColor[color];
    if (paths === undefined) {
      paths = {
        cur: null,
        previousParts: []
      };
      pathsByColor[color] = paths;
    }
    if (paths.cur !== null && (x1 != paths.cur.curX || !intervalsOverlap(y1, y2, paths.cur.curTop, paths.cur.curBottom))) {
      closePath(paths);
    }
    if (paths.cur === null) {
      paths.cur = {
        bottomPath: d.M(x1, y2) + d.H(x2),
        curX: x2,
        curBottom: y2,
        curTop: y1,
        connectPath: d.V(y1),
        topReversePath: d.H(x1) + d.z
      };
    } else {
      // Now, paths.cur.curX == x1.
      var bottomPath = paths.cur.bottomPath;
      if (paths.cur.curBottom != y2) {
        bottomPath += d.V(y2);
      }
      bottomPath = bottomPath + d.H(x2);
      var topReversePath = paths.cur.topReversePath;
      if (paths.cur.curTop != y1) {
        topReversePath = d.V(paths.cur.curTop) + topReversePath;
      }
      topReversePath = d.H(x1) + topReversePath;
      paths.cur = {
        bottomPath: bottomPath,
        curX: x2,
        curBottom: y2,
        curTop: y1,
        connectPath: d.V(y1),
        topReversePath: topReversePath
      };
    }
  };
  for (var _iterator2 = _createForOfIteratorHelperLoose(inEdgeSteps), _step3; !(_step3 = _iterator2()).done;) {
    var step = _step3.value;
    var s = step.values.reduce(function (acc, _ref4) {
      var value = _ref4.value;
      return acc + value;
    }, 0) * flowScale;
    var y = edgeStart[1] - s / 2;
    for (var _iterator3 = _createForOfIteratorHelperLoose(step.values), _step4; !(_step4 = _iterator3()).done;) {
      var _step4$value = _step4.value,
        color = _step4$value.color,
        value = _step4$value.value;
      var myY = y;
      y += value * flowScale;
      addRect(color, edgeStart[0] + normOffsetted - step.start / transitTime * normOffsetted, myY, edgeStart[0] + normOffsetted - step.end / transitTime * normOffsetted, myY + value * flowScale);
    }
  }
  closePaths();
  return Object.fromEntries(Object.entries(pathsByColor).map(function (_ref3) {
    var color = _ref3[0],
      previousParts = _ref3[1].previousParts;
    return [color, previousParts.join('')];
  }));
};
var InEdgeStepsPathBased = function InEdgeStepsPathBased(_ref5) {
  var inEdgeSteps = _ref5.inEdgeSteps,
    flowScale = _ref5.flowScale,
    edgeStart = _ref5.edgeStart,
    transitTime = _ref5.transitTime,
    normOffsetted = _ref5.normOffsetted;
  var inEdgePaths = computeDrawPathsFromInEdgeSteps(inEdgeSteps, flowScale, edgeStart, transitTime, normOffsetted);
  return React.createElement(React.Fragment, null, Object.entries(inEdgePaths).map(function (_ref6) {
    var color = _ref6[0],
      path = _ref6[1];
    return React.createElement("path", {
      key: color,
      fill: color,
      stroke: "none",
      d: path
    });
  }));
};
var InEdgeStepsRectBased = function InEdgeStepsRectBased(_ref7) {
  var inEdgeSteps = _ref7.inEdgeSteps,
    flowScale = _ref7.flowScale,
    edgeStart = _ref7.edgeStart,
    transitTime = _ref7.transitTime,
    normOffsetted = _ref7.normOffsetted;
  return React.createElement(React.Fragment, null, inEdgeSteps.map(function (_ref8, index1) {
    var start = _ref8.start,
      end = _ref8.end,
      values = _ref8.values;
    var s = values.reduce(function (acc, _ref9) {
      var value = _ref9.value;
      return acc + value;
    }, 0) * flowScale;
    var y = edgeStart[1] - s / 2;
    return values.map(function (_ref10, index2) {
      var color = _ref10.color,
        value = _ref10.value;
      var myY = y;
      y += value * flowScale;
      return React.createElement("rect", {
        key: index1 + "-" + index2,
        fill: color,
        x: edgeStart[0] + normOffsetted - end / transitTime * normOffsetted,
        y: myY,
        width: (end - start) / transitTime * normOffsetted,
        height: value * flowScale
      });
    });
  }).flat());
};
var BaseEdge = function BaseEdge(_ref11) {
  var multiGroup = _ref11.multiGroup,
    translate = _ref11.translate,
    svgIdPrefix = _ref11.svgIdPrefix,
    waitingTimeScale = _ref11.waitingTimeScale,
    transitTime = _ref11.transitTime,
    visible = _ref11.visible,
    from = _ref11.from,
    to = _ref11.to,
    offset = _ref11.offset,
    strokeWidth = _ref11.strokeWidth,
    flowScale = _ref11.flowScale,
    capacity = _ref11.capacity,
    _ref11$inEdgeSteps = _ref11.inEdgeSteps,
    inEdgeSteps = _ref11$inEdgeSteps === void 0 ? [] : _ref11$inEdgeSteps,
    _ref11$queueSteps = _ref11.queueSteps,
    queueSteps = _ref11$queueSteps === void 0 ? [] : _ref11$queueSteps,
    id = _ref11.id,
    _ref11$renderingMode = _ref11.renderingMode,
    renderingMode = _ref11$renderingMode === void 0 ? 'path-based' : _ref11$renderingMode;
  var width = flowScale * capacity;
  var padding = offset;
  var arrowHeadWidth = offset / 2;
  var arrowHeadHeight = multiGroup ? width : 2 * width;
  var delta = [to[0] - from[0], to[1] - from[1]];
  var norm = Math.sqrt(Math.pow(delta[0], 2) + Math.pow(delta[1], 2));
  // start = from + (to - from)/|to - from| * 30
  var pad = [delta[0] / norm * padding, delta[1] / norm * padding];
  var edgeStart = [from[0] + pad[0], from[1] + pad[1]];
  var deg = Math.atan2(to[1] - from[1], to[0] - from[0]) * 180 / Math.PI;
  //return <path d={`M${start[0]},${start[1]}L${end[0]},${end[1]}`} />
  var normOffsetted = norm - 2 * padding - arrowHeadWidth;
  return React.createElement("g", {
    transform: "rotate(" + deg + ", " + edgeStart[0] + ", " + edgeStart[1] + ") translate(0 " + translate + ")",
    style: {
      transition: 'opacity 0.2s'
    },
    opacity: visible ? 1 : 0,
    "data-id": id
  }, React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    stroke: "black",
    fill: "lightgray",
    d: d.M(edgeStart[0] + normOffsetted + strokeWidth / 2, edgeStart[1] - arrowHeadHeight / 2 - strokeWidth / 2) + d.l(arrowHeadWidth, arrowHeadHeight / 2 + strokeWidth / 2) + d.l(-arrowHeadWidth, arrowHeadHeight / 2 + strokeWidth / 2) + d.z
  }), React.createElement("rect", {
    x: edgeStart[0],
    y: edgeStart[1] - width / 2,
    width: normOffsetted,
    height: width,
    fill: "white",
    stroke: "none"
  }), renderingMode === 'path-based' ? React.createElement(InEdgeStepsPathBased, {
    edgeStart: edgeStart,
    flowScale: flowScale,
    inEdgeSteps: inEdgeSteps,
    normOffsetted: normOffsetted,
    transitTime: transitTime
  }) : React.createElement(InEdgeStepsRectBased, {
    edgeStart: edgeStart,
    flowScale: flowScale,
    inEdgeSteps: inEdgeSteps,
    normOffsetted: normOffsetted,
    transitTime: transitTime
  }), React.createElement("g", {
    mask: "url(#" + svgIdPrefix + "fade-mask)"
  }, queueSteps.map(function (_ref12, index1) {
    var start = _ref12.start,
      end = _ref12.end,
      values = _ref12.values;
    var x = edgeStart[0] - width;
    return values.slice(0).reverse().map(function (_ref13, index2) {
      var color = _ref13.color,
        value = _ref13.value;
      var myX = x;
      x += value * flowScale;
      return React.createElement("rect", {
        key: index1 + "-" + index2,
        fill: color,
        x: myX,
        y: edgeStart[1] - width + start * waitingTimeScale,
        width: value * flowScale,
        height: (end - start) * waitingTimeScale
      });
    });
  }).flat()), React.createElement("path", {
    stroke: "gray",
    strokeWidth: strokeWidth,
    style: {
      transition: 'opacity 0.2s'
    },
    opacity: queueSteps.length > 0 ? 1 : 0,
    fill: "none",
    d: d.M(edgeStart[0], edgeStart[1]) + d.c(-width / 2, 0, -width / 2, 0, -width / 2, -width)
  }), React.createElement("rect", {
    strokeLinejoin: "round",
    x: edgeStart[0] - strokeWidth / 2,
    y: edgeStart[1] - width / 2 - strokeWidth / 2,
    width: normOffsetted + strokeWidth,
    height: width + strokeWidth,
    stroke: "black",
    strokeWidth: strokeWidth,
    fill: "none"
  }));
};
var FlowEdge = function FlowEdge(_ref14) {
  var flowScale = _ref14.flowScale,
    id = _ref14.id,
    translate = _ref14.translate,
    multiGroup = _ref14.multiGroup,
    waitingTimeScale = _ref14.waitingTimeScale,
    strokeWidth = _ref14.strokeWidth,
    svgIdPrefix = _ref14.svgIdPrefix,
    from = _ref14.from,
    to = _ref14.to,
    outflowSteps = _ref14.outflowSteps,
    queue = _ref14.queue,
    t = _ref14.t,
    capacity = _ref14.capacity,
    transitTime = _ref14.transitTime,
    _ref14$visible = _ref14.visible,
    visible = _ref14$visible === void 0 ? true : _ref14$visible,
    offset = _ref14.offset;
  var _splitOutflowSteps = splitOutflowSteps(outflowSteps, queue, transitTime, capacity, t),
    inEdgeSteps = _splitOutflowSteps.inEdgeSteps,
    queueSteps = _splitOutflowSteps.queueSteps;
  return React.createElement(BaseEdge, {
    strokeWidth: strokeWidth,
    offset: offset,
    translate: translate,
    multiGroup: multiGroup,
    waitingTimeScale: waitingTimeScale,
    svgIdPrefix: svgIdPrefix,
    visible: visible,
    from: from,
    to: to,
    id: id,
    transitTime: transitTime,
    flowScale: flowScale,
    capacity: capacity,
    inEdgeSteps: inEdgeSteps,
    queueSteps: queueSteps
  });
};
var Vertex = function Vertex(_ref15) {
  var label = _ref15.label,
    pos = _ref15.pos,
    _ref15$visible = _ref15.visible,
    visible = _ref15$visible === void 0 ? true : _ref15$visible,
    radius = _ref15.radius,
    strokeWidth = _ref15.strokeWidth;
  var cx = pos[0],
    cy = pos[1];
  return React.createElement("g", {
    style: {
      transition: 'opacity 0.2s'
    },
    opacity: visible ? 1 : 0
  }, React.createElement("circle", {
    cx: cx,
    cy: cy,
    r: radius,
    stroke: "black",
    strokeWidth: strokeWidth,
    fill: "white"
  }), label !== null ? React.createElement("text", {
    x: cx,
    y: cy,
    style: {
      textAnchor: 'middle',
      dominantBaseline: 'central',
      fontSize: radius,
      userSelect: 'none'
    }
  }, label) : null);
};

var useOutflowSteps = function useOutflowSteps(flow, network) {
  return React.useMemo(function () {
    return flow.outflow.map(function (outflow) {
      return calcOutflowSteps(outflow, network.commoditiesMap);
    });
  }, [flow, network]);
};
var useEdgesWithViewOpts = function useEdgesWithViewOpts(flow, network, strokeWidth, flowScale) {
  return React.useMemo(function () {
    var grouped = groupBy(network.edgesMap, function (_ref) {
      var from = _ref.from,
        to = _ref.to;
      return JSON.stringify(from < to ? [from, to] : [to, from]);
    });
    var result = [];
    for (var _i = 0, _Object$values = Object.values(grouped); _i < _Object$values.length; _i++) {
      var group = _Object$values[_i];
      group.sort(function (a, b) {
        return a.from < b.from ? -1 : 1;
      });
      var totalCapacity = group.reduce(function (acc, edge) {
        return acc + edge.capacity;
      }, 0);
      var translate = -totalCapacity * flowScale / 2 - strokeWidth * (group.length + 1) / 2;
      for (var _iterator = _createForOfIteratorHelperLoose(group), _step; !(_step = _iterator()).done;) {
        var edge = _step.value;
        var edgeTranslate = translate + edge.capacity * flowScale / 2 + strokeWidth / 2;
        translate += edge.capacity * flowScale + strokeWidth;
        result.push({
          translate: edgeTranslate * (edge.from < edge.to ? -1 : 1),
          edge: edge,
          multiGroup: group.length > 1
        });
      }
    }
    return result;
  }, [flow, network, strokeWidth, flowScale]);
};
var EdgesCoordinator = function EdgesCoordinator(props) {
  var nodesMap = props.network.nodesMap;
  var outflowSteps = useOutflowSteps(props.flow, props.network);
  var edgesWithViewOpts = useEdgesWithViewOpts(props.flow, props.network, props.strokeWidth, props.flowScale);
  return React.createElement(React.Fragment, null, edgesWithViewOpts.map(function (_ref2) {
    var edge = _ref2.edge,
      translate = _ref2.translate,
      multiGroup = _ref2.multiGroup;
    var fromNode = nodesMap[edge.from];
    var toNode = nodesMap[edge.to];
    return React.createElement(FlowEdge, {
      id: edge.id,
      waitingTimeScale: props.waitingTimeScale,
      strokeWidth: props.strokeWidth,
      flowScale: props.flowScale,
      translate: translate,
      multiGroup: multiGroup,
      key: edge.id,
      t: props.t,
      capacity: edge.capacity,
      offset: props.edgeOffset,
      from: [fromNode.x, fromNode.y],
      to: [toNode.x, toNode.y],
      svgIdPrefix: props.svgIdPrefix,
      outflowSteps: outflowSteps[edge.id],
      transitTime: edge.transitTime,
      queue: props.flow.queues[edge.id]
    });
  }));
};

var DynamicFlowSvg = function DynamicFlowSvg(_ref) {
  var _ref$t = _ref.t,
    t = _ref$t === void 0 ? 0 : _ref$t,
    _ref$svgIdPrefix = _ref.svgIdPrefix,
    svgIdPrefix = _ref$svgIdPrefix === void 0 ? '' : _ref$svgIdPrefix,
    network = _ref.network,
    flow = _ref.flow,
    nodeRadius = _ref.nodeRadius,
    edgeOffset = _ref.edgeOffset,
    strokeWidth = _ref.strokeWidth,
    flowScale = _ref.flowScale,
    waitingTimeScale = _ref.waitingTimeScale;
  return React.createElement(React.Fragment, null, React.createElement(DynamicFlowSvgDefs, {
    svgIdPrefix: svgIdPrefix
  }), React.createElement(EdgesCoordinator, {
    network: network,
    waitingTimeScale: waitingTimeScale,
    strokeWidth: strokeWidth,
    flowScale: flowScale,
    svgIdPrefix: svgIdPrefix,
    edgeOffset: edgeOffset,
    flow: flow,
    t: t
  }), Object.values(network.nodesMap).map(function (node) {
    var _node$label;
    return React.createElement(Vertex, {
      key: node.id,
      strokeWidth: strokeWidth,
      radius: nodeRadius,
      pos: [node.x, node.y],
      label: (_node$label = node.label) != null ? _node$label : node.id.toString()
    });
  }));
};

export { BaseEdge, DynamicFlowSvg, DynamicFlowSvgDefs, EdgesCoordinator, Flow, FlowEdge, Network, PiecewiseLinear, RightConstant, Vertex, calcOutflowSteps, elemLRank, elemRank };
//# sourceMappingURL=dynamicflowvisualization.esm.js.map
